import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import DashboardOverview from "@/pages/DashboardOverview";
import ManageItems from "@/pages/ManageItems";
import ManageOrders from "@/pages/ManageOrders";
import ManageSettings from "@/pages/ManageSettings";
import ManageReports from "@/pages/ManageReports";
import ManageUsers from "@/pages/ManageUsers";
import ManageSubscriptions from "@/pages/ManageSubscriptions";
import ManagePickups from "@/pages/ManagePickups";
import ManageAuditLogs from "@/pages/ManageAuditLogs";
import InscricaoPage from "@/pages/InscricaoPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/inscricao" element={<InscricaoPage />} />
            <Route path="/pedido/:txid" element={<TrackOrderPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardOverview />} />
              <Route path="itens" element={<ManageItems />} />
              <Route path="pedidos" element={<ManageOrders />} />
              <Route path="inscricoes" element={<ManageSubscriptions />} />
              <Route path="retiradas" element={<ManagePickups />} />
              <Route path="relatorios" element={<ManageReports />} />
              <Route
                path="auditoria"
                element={
                  <ProtectedRoute adminOnly>
                    <ManageAuditLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="usuarios"
                element={
                  <ProtectedRoute adminOnly>
                    <ManageUsers />
                  </ProtectedRoute>
                }
              />
              <Route path="configuracoes" element={<ManageSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
